const TurnMove = {
  ONE: 1,
  TWO: 2,
};

export default TurnMove;
